//
// Shop: Compare
//

"use strict";

( function($, waTheme) {

    var Compare = ( function($) {

        var change_functions = [];

        Compare = function(options) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$count = that.$wrapper.find(".js-compare-wrapper__count");
            that.onChange = options["onChange"];

            // VARS

            // DYNAMIC VARS
            that.count = null;

            // INIT
            that.initClass();
        };

        Compare.prototype.initClass = function() {
            var that = this;

            $(document).on('click', '.js-add-compare-button', function () {
                var product_id = $(this).data("product-id"),
                    $buttons = $(`.js-add-compare-button[data-product-id="${product_id}"]`),
                    is_added = $(this).hasClass("active");

                $buttons.toggleClass("active");
                if (is_added) {
                    $buttons.find(".b-compare__text").text(window.waTheme.locale.to_comparison);
                } else {
                    $buttons.find(".b-compare__text").text(window.waTheme.locale.in_comparison);
                }

                that.addToCompare($(this), product_id);
            });

            if (that.onChange && (typeof that.onChange === "function") ) {
                change_functions.push(that.onChange);
            }
        };

        Compare.prototype.update = function() {
            var that = this,
                compare = $.cookie("shop_compare"),
                count;

            compare = (compare) ? compare.split(',') : [];
            count = compare.length;

            if ( count > 0 ) {
                that.$count.text(count);
                that.toggle(true);
            } else {
                that.$count.text(0);
                that.toggle();
            }

            that.count = count;

            $.each(change_functions, function(index, func) {
                try {
                    func(that);
                } catch(e) {
                    console.log(e.message);
                }
            });

            // событие обновления товаров в списке сравнения
            $(document).trigger('update_compare_counter');
        };

        Compare.prototype.toggle = function(show) {
            var that = this,
                active_class = "d-none";

            if (show) {
                that.$count.removeClass(active_class);
            } else {
                that.$count.addClass(active_class);
            }
        };

        /**
         * @param {String|Number} product_id
         * @return {Boolean}
         * */
        Compare.prototype.addToCompare = function($button, product_id) {
            var that = this;

            product_id = product_id + "";

            var cookie_name = "shop_compare",
                cookie_compare = $.cookie(cookie_name),
                compare_ids = (cookie_compare) ? cookie_compare.split(',') : [],
                index = compare_ids.indexOf(product_id),
                is_added = (index >= 0);

            if (is_added) {
                remove(product_id);
                that.update();
                that.toast($button, window.waTheme.locale.product_removed_from_compare);

                $button.removeClass("active");
                $button.find(".b-compare__text").text(window.waTheme.locale.to_comparison);
            } else {
                add(product_id);
                that.update();
                that.toast($button, window.waTheme.locale.product_added_to_compare);

                $button.addClass("active");
                $button.find(".b-compare__text").text(window.waTheme.locale.in_comparison);
            }

            return !is_added;

            /**
             * @param {String} product_id
             * */
            function add(product_id) {
                compare_ids.push(product_id);
                $.cookie(cookie_name, compare_ids.join(','), {expires: 30, path: '/'});
            }

            /**
             * @param {String} product_id
             * */
            function remove(product_id) {
                compare_ids.splice(index, 1);

                if (compare_ids.length > 0) {
                    $.cookie(cookie_name, compare_ids.join(','), { expires: 30, path: '/'});
                } else {
                    $.cookie(cookie_name, "", {path: '/'});
                }
            }
        };

        Compare.prototype.toast = function($button, text) {
            var that = this,
                product_name = $button.data("product-name"),
                product_image = $button.data("product-image");

            let toastHTML =
                `<a class="b-products-toast d-flex" href="${window.waTheme.compare_url}">
                    <div class="b-products-toast__image">
                       <img src="${product_image}">
                    </div>
                    <div class="ms-3">
                        <div class="fs-md fw-bold mb-1 text-dark">
                           ${text}
                        </div>
                        <div class="fs-sm mb-1">
                            <span class="text-dark">${product_name}</span>
                        </div>
                        <div class="link-theme fs-sm">
                            ${window.waTheme.locale.go_to_compare}
                        </div>
                    </div>
                </a>`;

            const toast = new window.waTheme.init.site.Toast({
                html: toastHTML
            });
        };

        /**
         * @param {Function} func
         * */
        Compare.prototype.onChange = function(func) {
            if (typeof func === "function") {
                change_functions.push(func);
            }
        };

        return Compare;
    })($);

    waTheme.init.shop.Compare = Compare;

    let $compare = $(".js-compare-wrapper");
    if ($compare.length) {
        waTheme.apps["shop"].compare = new window.waTheme.init.shop.Compare({
            $wrapper: $compare,
            // onChange: function(compare) {
                // var hover_class = "with-hover";
                // if (compare.count > 0) {
                //     $compare.addClass(hover_class);
                // } else {
                //     $compare.removeClass(hover_class);
                // }
            // }
        });
    }

})(jQuery, window.waTheme);
